import _getIterator from "babel-runtime/core-js/get-iterator";
// Counts all occurences of a symbol in a string
export function count_occurences(symbol, string) {
	var count = 0;

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _getIterator(string), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var character = _step.value;

			if (character === symbol) {
				count++;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return count;
}
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/input-format/es6/helpers.js
// module id = ./node_modules/input-format/es6/helpers.js
// module chunks = 0 1 2